import { createAction, props } from '@ngrx/store';
import { Selectable } from 'app/shared/models/selectable';
import { InstallationType } from 'app/shared/models/location-details';
import { EntityResponseItem } from 'app/shared/models/view-data';
import { LocationCardMonitorSeries } from 'app/shared/models/monitorsetting';
import { RainLocation } from 'app/shared/models/locations';

export enum OptionsActionType {
    // Installation types
    LOAD_INSTALLATION_TYPES = '@form/options/LOAD_INSTALLATION_TYPES',
    LOAD_INSTALLATION_TYPES_SUCCESS = '@form/options/LOAD_INSTALLATION_TYPES_SUCCESS',
    LOAD_INSTALLATION_TYPES_FAILURE = '@form/options/LOAD_INSTALLATION_TYPES_FAILURE',

    // Rain gauges
    LOAD_RAIN_GAUGES = '@form/options/LOAD_RAIN_GAUGES',

    // Modem providers
    LOAD_MODEM_PROVIDERS = '@form/options/LOAD_MODEM_PROVIDERS',
    LOAD_MODEM_PROVIDERS_SUCCESS = '@form/options/LOAD_MODEM_PROVIDERS_SUCCESS',
    LOAD_MODEM_PROVIDERS_FAILURE = '@form/options/LOAD_MODEM_PROVIDERS_FAILURE',

    // QFinal entities
    LOAD_QFINAL_ENTITIES = '@form/options/LOAD_QFINAL_ENTITIES',
    LOAD_QFINAL_ENTITIES_SUCCESS = '@form/options/LOAD_QFINAL_ENTITIES_SUCCESS',
    LOAD_QFINAL_ENTITIES_FAILURE = '@form/options/LOAD_QFINAL_ENTITIES_FAILURE',

    // Tag keys
    TAG_KEY_CHANGE = '@form/options/TAG_KEY_CHANGE',
    
    // Monitor series
    LOAD_MONITOR_SERIES = '@form/options/LOAD_MONITOR_SERIES',
    
    // Custom properties
    LOAD_CUSTOM_PROPERTIES = '@form/LOAD_CUSTOM_PROPERTIES',
    LOAD_CUSTOM_PROPERTIES_SUCCESS = '@form/LOAD_CUSTOM_PROPERTIES_SUCCESS',
}

// Installation type actions
export const loadInstallationTypes = createAction(
    OptionsActionType.LOAD_INSTALLATION_TYPES,
    props<{ installationId: number }>(),
);

export const loadInstallationTypesSuccess = createAction(
    OptionsActionType.LOAD_INSTALLATION_TYPES_SUCCESS,
    props<{ data: InstallationType[] }>(),
);

export const loadInstallationTypesFailure = createAction(
    OptionsActionType.LOAD_INSTALLATION_TYPES_FAILURE,
    props<{ error: unknown }>(),
);

// Modem provider actions
export const loadModemProviders = createAction(OptionsActionType.LOAD_MODEM_PROVIDERS);

export const loadModemProvidersSuccess = createAction(
    OptionsActionType.LOAD_MODEM_PROVIDERS_SUCCESS,
    props<{ data: Selectable[] }>(),
);

export const loadModemProvidersFailure = createAction(
    OptionsActionType.LOAD_MODEM_PROVIDERS_FAILURE,
    props<{ optionType: string }>(),
);

// Rain gauge actions
export const loadRainGauges = createAction(OptionsActionType.LOAD_RAIN_GAUGES, props<{ data: RainLocation[] }>());

// QFinal entity actions
export const loadQFinalEntities = createAction(
    OptionsActionType.LOAD_QFINAL_ENTITIES,
    props<{ customerId: number; locationId: number }>(),
);

export const loadQFinalEntitiesSuccess = createAction(
    OptionsActionType.LOAD_QFINAL_ENTITIES_SUCCESS,
    props<{ data: EntityResponseItem[] }>(),
);

export const loadQFinalEntitiesFailure = createAction(
    OptionsActionType.LOAD_QFINAL_ENTITIES_FAILURE,
    props<{ error: unknown }>(),
);

// Tag key actions
export const tagKeyChange = createAction(
    OptionsActionType.TAG_KEY_CHANGE,
    props<{ fieldId: string; newValue: string; isMp1: boolean }>(),
);

// Monitor series actions
export const loadMonitorSeries = createAction(
    OptionsActionType.LOAD_MONITOR_SERIES,
    props<{ series: LocationCardMonitorSeries[] }>(),
);

// Custom properties actions
export const loadCustomProperties = createAction(
    OptionsActionType.LOAD_CUSTOM_PROPERTIES,
    props<{ customerId: number }>(),
);

export const loadCustomPropertiesSuccess = createAction(
    OptionsActionType.LOAD_CUSTOM_PROPERTIES_SUCCESS,
    props<{ data: string[] }>(),
);